export default __webpack_public_path__ + "3MJppMM-logo_mini_black.svg";